import { atom } from 'jotai'

export const pictureInPictureAtom = atom<{ open: boolean }>({ open: false })
